var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2515",
    d: "M0-682.665H50v50H0Z",
    transform: "translate(0 682.665)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2505",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2507",
    transform: "translate(37.707 -676.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2509",
    d: "M3.242,1.375H.313a1.063,1.063,0,1,1,0-2.125h2.93a1.063,1.063,0,1,1,0,2.125Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2511",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2513",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2519",
    transform: "translate(33.826 23.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2521",
    d: "M11,1.375H.313a1.063,1.063,0,1,1,0-2.125H11a1.063,1.063,0,0,1,0,2.125Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2523",
    transform: "translate(30.383 -0.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2525",
    d: "M-225.038-296.741h-11.719a4,4,0,0,1-3.992-3.992v-24.023a4,4,0,0,1,3.992-3.992h11.719a4,4,0,0,1,3.992,3.992v24.023A4,4,0,0,1-225.038-296.741Zm-11.719-29.883a1.869,1.869,0,0,0-1.867,1.867v24.023a1.869,1.869,0,0,0,1.867,1.867h11.719a1.869,1.869,0,0,0,1.867-1.867v-24.023a1.869,1.869,0,0,0-1.867-1.867Z",
    transform: "translate(240.749 328.749)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2527",
    transform: "translate(-0.086 8.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2529",
    d: "M-535.453-253.812h-38.28a3.019,3.019,0,0,1-3.016-3.016v-28.906a3.019,3.019,0,0,1,3.016-3.016h28.516a1.063,1.063,0,0,1,1.063,1.062,1.063,1.063,0,0,1-1.062,1.063h-28.516a.892.892,0,0,0-.891.891v28.906a.892.892,0,0,0,.891.891h38.28a.892.892,0,0,0,.892-.891v-9.766a1.062,1.062,0,0,1,1.062-1.062,1.063,1.063,0,0,1,1.063,1.062v9.766A3.019,3.019,0,0,1-535.453-253.812Z",
    transform: "translate(576.749 288.749)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2531",
    transform: "translate(15.148 41.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2533",
    d: "M.313,7.82A1.063,1.063,0,0,1-.75,6.758V.313a1.063,1.063,0,0,1,2.125,0V6.758A1.063,1.063,0,0,1,.313,7.82Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2535",
    transform: "translate(26.867 41.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2537",
    d: "M.313-80.18A1.063,1.063,0,0,1-.75-81.242v-6.445A1.063,1.063,0,0,1,.313-88.75a1.063,1.063,0,0,1,1.063,1.063v6.445A1.063,1.063,0,0,1,.313-80.18Z",
    transform: "translate(0.75 88.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2539",
    transform: "translate(9.289 47.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2541",
    d: "M23.75,1.375H.313a1.063,1.063,0,1,1,0-2.125H23.75a1.063,1.063,0,1,1,0,2.125Z",
    transform: "translate(0.75 0.75)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2551",
    transform: "translate(2.649 35.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2553",
    d: "M-190.968,1.375h-36.719A1.063,1.063,0,0,1-228.75.313,1.063,1.063,0,0,1-227.687-.75h36.719A1.062,1.062,0,0,1-189.906.313,1.062,1.062,0,0,1-190.968,1.375Z",
    transform: "translate(228.75 0.75)",
    fill: "#09143a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.46b018a86781dd420967563353fee636.svg";
export { ForwardRef as ReactComponent };